import { useQuery } from '@tanstack/react-query'
import { useSearch } from '@tanstack/react-router'

import { clientPortalPublicCaseInformationQuery } from '@/lib/queries/case-dashboard/queries'

import { useClientPortalPublicUrlParams } from './use-client-portal-public-url-params'

export const useClientPortalPublicData = () => {
  const { caseId } = useClientPortalPublicUrlParams()
  const { companyId } = useSearch({
    from: '/client-portal/public/$encodedCaseId',
  })
  const { data: dataClientPortalPublic } = useQuery(
    clientPortalPublicCaseInformationQuery({
      caseId: Number(caseId),
      companyId,
    })
  )

  const dataProUserSelectedCases = dataClientPortalPublic?.relevantCase
  const caseNumber = dataClientPortalPublic?.caseInfo.caseNumber

  const isUscisCase = dataClientPortalPublic?.caseInfo.applicationType === 'uscis'

  return {
    caseId: Number(caseId),
    caseNumber,
    companyId,
    isUscisCase,
    dataClientPortalPublic,
    dataProUserSelectedCases,
  }
}
